import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { apenasNumeros, apenasMonetario } from "@/services/utils";
import { formatMonetario } from "@/services/utils";
import { useSelector } from "react-redux";
import { initialValuesForm } from "../camposUsuario";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import BotaoPrincipal from "@/components/BotaoPrincipal";
import InputMask from "react-input-mask";
import Select from "@mui/material/Select";
import Logo from "@/components/Logo";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import LogoQuitaWhitelabel from "@/components/LogoQuitaWhitelabel";
import * as Yup from "yup";
import InputCpfCnpj from "@/components/InputCpfCnpj";

export default function DadosPessoaisParceiro({
  setNavegarEtapa,
  dadosUsuario,
  carregarEtapa,
  setCarregarEtapa,
  setDadosUsuario,
  limparDados,
}) {
  const user = useSelector((state) => state.user);
  const [usuarioJaCadastrado, setUsuarioJaCadastrado] = useState(false);

  const Schema = Yup.object().shape({
    billValue: Yup.string().when("reverseSimulator", {
      is: "N",
      then: () => Yup.string().required("Informe o valor da simulação"),
    }),
    creditLimit: Yup.string().when("reverseSimulator", {
      is: "S",
      then: () => Yup.string().required("Informe o valor da simulação"),
    }),
  });

  const salvar = async (values) => {
    values = { ...values };
    values.useReverseSimulator = values.reverseSimulator === "S";
    values.whatsapp = apenasNumeros(values.whatsapp);
    values.billValue = apenasMonetario(values.billValue);
    values.cpfCnpj = apenasNumeros(values.cpfCnpj);
    return values;
  };

  const formik = useFormik({
    initialValues: initialValuesForm,
    validationSchema: Schema,
    onSubmit: async (values) => {
      const result = await salvar(values);

      setDadosUsuario(result);
      setNavegarEtapa(2);
    },
  });

  useEffect(() => {
    if (!carregarEtapa) {
      return;
    }
    setCarregarEtapa(false);
    if (user.idCompanyBind) {
      dadosUsuario.idCompany = user.idCompanyBind;
    }
    const cpfCnpj = dadosUsuario.cpf || dadosUsuario.cnpj;
    if (cpfCnpj) {
      dadosUsuario.cpfCnpj = cpfCnpj;
    }
    if (dadosUsuario.useReverseSimulator) {
      dadosUsuario.creditLimit = dadosUsuario.total || 0;
      dadosUsuario.reverseSimulator = "S";
    } else {
      dadosUsuario.reverseSimulator = "N";
    }
    formik.setValues(dadosUsuario);
  }, [
    carregarEtapa,
    user.idCompanyBind,
    setCarregarEtapa,
    dadosUsuario,
    formik,
  ]);

  const camposInvalidos = () => {
    return Object.values(formik.errors).length > 0 && formik.submitCount > 0;
  };

  const limparDadosEtapa = () => {
    formik.resetForm();
    limparDados();
  };

  return (
    <>
      <Grid container>
        <Grid item size={12} sx={{ display: "flex", justifyContent: "center" }}>
          <Logo></Logo>
          <LogoQuitaWhitelabel
            style={{
              margin: "auto 5px auto",
              maxWidth: "100px",
            }}></LogoQuitaWhitelabel>
        </Grid>
      </Grid>

      <>
        <Alert severity="info" style={{ marginBottom: "1rem" }}>
          <Typography>
            Informe o valor total dos <b>boletos</b> ou <b>PIX</b> para simular
            o parcelamento.
          </Typography>
          <Typography>Simule e solicite o parcelamento agora mesmo:</Typography>
        </Alert>
      </>

      {formik.values?.infoPartner?.billValue > 0 && (
        <>
          <>
            <Typography align="center">
              Valor solicitado{" "}
              <b>{formatMonetario(formik.values.infoPartner.billValue)}</b>.
            </Typography>
          </>
          {!!formik.values?.infoPartner?.installments && (
            <>
              <Typography align="center">
                <b>
                  {formik.values.infoPartner.installments}x de{" "}
                  {formatMonetario(formik.values.infoPartner.installmentValue)}
                </b>
                .
              </Typography>
            </>
          )}

          <Typography
            align="center"
            variant="h6"
            style={{ marginBottom: "0.5rem" }}>
            Preencha seus dados para continuar!
          </Typography>
        </>
      )}

      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
          {!formik.values?.infoPartner?.billValue && (
            <>
              {!!user.companyBase.useReverseSimulator && (
                <Grid item size={12}>
                  <Grid container>
                    <Grid item size={{ xs: 12, sm: 6 }}>
                      <InputLabel shrink id="label-select-province">
                        Simular com
                      </InputLabel>
                      <Select
                        labelId="label-select-province"
                        id="reverseSimulator"
                        name="reverseSimulator"
                        label="Simular com *"
                        fullWidth
                        variant="outlined"
                        placeholder="Selecione.."
                        value={formik.values.reverseSimulator}
                        onChange={formik.handleChange}>
                        <MenuItem value="N">Valor total dos débitos</MenuItem>
                        <MenuItem value="S">Limite disponível</MenuItem>
                      </Select>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid item size={{ xs: 12, sm: 6 }}>
                {formik.values.reverseSimulator === "S" && (
                  <TextField
                    sx={{ my: 2 }}
                    fullWidth
                    type="number"
                    name="creditLimit"
                    label={"Limite disponível*"}
                    onWheel={() => document.activeElement.blur()}
                    variant="outlined"
                    placeholder="R$ 0,00"
                    value={formik.values.creditLimit}
                    onChange={formik.handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    error={
                      formik.touched.creditLimit &&
                      Boolean(formik.errors.creditLimit)
                    }
                    helperText={
                      formik.touched.creditLimit && formik.errors.creditLimit
                    }
                  />
                )}
                {formik.values.reverseSimulator === "N" && (
                  <TextField
                    sx={{ my: 2 }}
                    fullWidth
                    type="number"
                    name="billValue"
                    label={"Valor total dos boletos ou PIX*"}
                    onWheel={() => document.activeElement.blur()}
                    variant="outlined"
                    placeholder="R$ 0,00"
                    value={formik.values.billValue}
                    onChange={formik.handleChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    error={
                      formik.touched.billValue &&
                      Boolean(formik.errors.billValue)
                    }
                    helperText={
                      formik.touched.billValue && formik.errors.billValue
                    }
                  />
                )}
              </Grid>

              <Grid
                item
                size={{ xs: 12, sm: 6 }}
                sx={{
                  textAlign: "center",
                  display: "flex",
                  alignItems: "end",
                }}>
                {formik.values.billValue && (
                  <Typography
                    sx={{ my: 2 }}
                    p={1}
                    onClick={formik.handleSubmit}
                    style={{
                      fontSize: "12px",
                      background: "#e5f6fd",
                      borderRadius: "8px",
                    }}>
                    {`Simular com ${formatMonetario(
                      formik.values.reverseSimulator === "S"
                        ? formik.values.creditLimit
                        : formik.values.billValue
                    )}`}
                  </Typography>
                )}
              </Grid>
            </>
          )}

          <Grid item size={{ xs: 12, sm: 6 }}>
            <InputCpfCnpj
              {...{
                formik,
                setUsuarioJaCadastrado,
                searchClientData: true,
                label: "CPF/CNPJ",
              }}
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <TextField
              id="name"
              name="name"
              label={
                formik.values.personType === "PJ" ? "Razão social" : "Nome"
              }
              fullWidth
              autoComplete="given-name"
              variant="outlined"
              slotProps={{
                input: {
                  readOnly: usuarioJaCadastrado,
                },
              }}
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />
          </Grid>

          <Grid item size={{ xs: 12, sm: 6 }}>
            <InputMask
              mask="(99) 9 9999-9999"
              value={formik.values.whatsapp}
              name="whatsapp"
              onChange={formik.handleChange}>
              {() => (
                <TextField
                  id="whatsapp"
                  name="whatsapp"
                  label={`Telefone/WhatsApp`}
                  fullWidth
                  autoComplete="tel"
                  variant="outlined"
                  slotProps={{
                    readOnly: usuarioJaCadastrado,
                  }}
                  error={
                    formik.touched.whatsapp && Boolean(formik.errors.whatsapp)
                  }
                  helperText={formik.touched.whatsapp && formik.errors.whatsapp}
                />
              )}
            </InputMask>
          </Grid>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <TextField
              name="email"
              label={`E-mail`}
              fullWidth
              autoComplete="email"
              variant="outlined"
              slotProps={{
                input: {
                  readOnly: usuarioJaCadastrado,
                },
              }}
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
          </Grid>

          {camposInvalidos() && (
            <Grid item size={12}>
              <Alert severity="warning">
                <Typography>
                  Verifique se os campos obrigatórios foram preenchidos
                  corretamente!
                </Typography>
              </Alert>
            </Grid>
          )}
        </Grid>
        <Grid container spacing={3}>
          <Grid item size={6}>
            {!formik.values?.infoPartner?.billValue && (
              <Box>
                <Button
                  onClick={() => {
                    limparDadosEtapa();
                  }}
                  sx={{ mt: 3, ml: 1 }}>
                  LIMPAR DADOS
                </Button>
              </Box>
            )}
          </Grid>
          <Grid item size={6}>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <BotaoPrincipal
                id="btn-avancar-dados-pessoais"
                type="submit"
                sx={{ mt: 3, ml: 1 }}>
                PRÓXIMO
              </BotaoPrincipal>
            </Box>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
